import React, { useContext, useEffect, useRef, useState } from "react";
import activoContext from "../../context/activoContex/activoContex";
import nivel1Context from "../../context/nivel1Context/nivel1Context";
import nivel2Context from "../../context/nivel2Context/nivel2Context";

import './SpatialTabActivos.css';
import DiamondIcon from '@mui/icons-material/Diamond';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiamond } from "@fortawesome/free-solid-svg-icons";
import nivel3Context from "../../context/nivel3Context/nivel3Context";
import Swal from "sweetalert2";
import authContext from "../../context/authentication/authContex";
import { getNewFormattedDate } from "../../utils/funciones";
import DictionaryText from "../dictionaryText/DictionaryText";
import SquareActivo from "./squareActivo";
import nivel4Context from "../../context/nivel4Context/nivel4Context";
import nivel5Context from "../../context/nivel5Context/nivel5Context";

const SpatialTabActivos = ({activosModelados}) =>{

    const acContext = useContext(activoContext);
    const {actualizarUbicacionActivo, activoList, getFilesActivo} = acContext;
    const arContext = useContext(nivel1Context);
    const {nivel1Lista} = arContext;
    const plContext = useContext(nivel2Context);
    const {nivel2List} = plContext;
    const prContext = useContext(nivel3Context);
    const {nivel3List} = prContext;
    const {nivel4List} = useContext(nivel4Context);
    const {nivel5List} = useContext(nivel5Context);
    const auContext = useContext(authContext);
    const { usuario } = auContext;
    const [areasModeladas,setNivel1sModeladas] = useState(undefined);
    const [draggedActivo,setDraggedActivo] = useState(null);

    const [overLv1,setOverLv1] = useState(null);
    const [overLv2,setOverLv2] = useState(null);
    const [overLv3,setOverLv3] = useState(null);
    const [overLv4,setOverLv4] = useState(null);
    const [overLv5,setOverLv5] = useState(null);

    const modelateNivel1s = async() =>{
        if(nivel1Lista != undefined && nivel2List != undefined && activosModelados != undefined){
            let activosListToUse = [...activosModelados];

            let areasModeladasToSet = [...nivel1Lista]
            areasModeladasToSet = areasModeladasToSet.map(lv1 => ({...lv1, nivel1ID: lv1._id, codNivel1: lv1.codNivel1, nivel1Name: lv1.name}));

            for(const lv1 of areasModeladasToSet){
                
                let activosFilteredPerLv1 = activosListToUse?.filter(act => (!act?.activoNivel2ID && act.activoNivel1ID == lv1._id))

                let nivel2sFiltered = nivel2List.filter(p => p.codNivel1 == lv1.codNivel1);
                nivel2sFiltered = nivel2sFiltered.map(p => ({...p, nivel1ID: lv1._id, codNivel1: lv1.codNivel1, nivel1Name: lv1.name, nivel2ID:p._id, codNivel2: p.codNivel2, nivel2Name: p.name}));

                if(activosListToUse.length > 0){
                    for(const p of nivel2sFiltered){

                        let activosFilteredPerLv2 = activosListToUse?.filter(act => (!act.activoNivel3ID && act.activoNivel2ID == p._id));

                        let nivel3sFiltered = nivel3List.filter(lv3 => lv3.nivel3Nivel2ID == p._id);

                        nivel3sFiltered = nivel3sFiltered.map(lv3 => ({...lv3, nivel3ID: lv3._id, nivel1ID: lv1._id, codNivel1: lv1.codNivel1, nivel1Name: lv1.name, nivel2ID:p._id, codNivel2: p.codNivel2, nivel2Name: p.name}));

                        for(const lv3 of nivel3sFiltered){

                            let activosFilteredPerLv3 = activosListToUse?.filter(act => (!act.activoNivel4ID && act.activoNivel3ID == lv3._id));
                            
                            let nivel4sFiltered = nivel4List.filter(lv4 => lv4.nivel4Nivel3ID == lv3._id);

                            nivel4sFiltered = nivel4sFiltered.map(lv4 => ({...lv4, nivel4ID: lv4._id, nivel1ID: lv1._id, codNivel1: lv1.codNivel1, nivel1Name: lv1.name, nivel2ID:p._id, codNivel2: p.codNivel2, nivel2Name: p.name, codNivel3: lv3.codNivel3, nameNivel3: lv3.nameNivel3, nivel3ID: lv3._id, codNivel4: lv4.codNivel4, nivel4Name: lv4.name}))

                            for(const lv4 of nivel4sFiltered){

                                let activosFilteredPerLv4 = activosListToUse?.filter(act =>  (!act.activoNivel5ID && act.activoNivel4ID == lv4._id));
                                
                                let nivel5sFiltered = nivel5List.filter(lv5 => lv5.nivel5Nivel4ID == lv4._id);
                                
                                nivel5sFiltered = nivel5sFiltered.map(lv5 => ({...lv5, nivel5ID: lv5._id, nivel1ID: lv1._id, codNivel1: lv1.codNivel1, nivel1Name: lv1.name, nivel2ID:p._id, codNivel2: p.codNivel2, nivel2Name: p.name, nivel3ID: lv3._id, codNivel3: lv3.codNivel3, nameNivel3: lv3.nameNivel3, nivel4ID:lv4._id, codNivel4: lv4.codNivel4, nivel4Name: lv4.name, codNivel5: lv5.codNivel5, nivel5Name: lv5.name}))
                                
                                for(const lv5 of nivel5sFiltered){
                                    let activosFiltered = activosListToUse.filter(a => a.activoNivel5ID == lv5._id);                                                      
                                    lv5.activosPerLevel5 = activosFiltered;
                                }

                                lv4.activosPerLevel4 = activosFilteredPerLv4;
                                lv4.nivel5s = nivel5sFiltered;
                            }


                            lv3.activosPerLevel3 = activosFilteredPerLv3;
                            lv3.nivel4s = nivel4sFiltered;
                        }

                        p.activosPerLevel2 = activosFilteredPerLv2;
                        p.nivel3s= nivel3sFiltered;

                    }
                }

                lv1.activosPerLevel1 = activosFilteredPerLv1;
                lv1.nivel2s = nivel2sFiltered;
            }
            setNivel1sModeladas(areasModeladasToSet);
        }
    }

    const handleDragStart = (e, fromNro) =>{
        setDraggedActivo({...e, fromNro});
    }

    const handleOnDrop = async(i, nivel, nivelNumero, event) =>{
        event.preventDefault(); 
        event.stopPropagation();
        if(overLv1) setOverLv1(null);
        if(overLv2) setOverLv2(null);
        if(overLv3) setOverLv3(null);
        if(overLv4) setOverLv4(null);
        if(overLv5) setOverLv5(null);

        const {fromNro} = draggedActivo;

        if(Object.keys(draggedActivo).length > 0){
            Swal.fire({
                title: `Esta seguro que desea realizar el siguiente traslado para el Activo ${draggedActivo.name}?`,
                icon: 'warning',
                html: `Origen:  ${draggedActivo.nivel1Name} ${fromNro > 1 ? `, ${draggedActivo.nivel2Name}` : '' } ${fromNro > 2 ? `, ${draggedActivo.nameNivel3}` : ''} ${fromNro > 3 ? `, ${draggedActivo.nivel4Name}` : '' } ${fromNro > 4 ? `, ${draggedActivo.nivel5Name}` : '' }. <br>
                Destino: ${nivel.nivel1Name} ${nivelNumero > 1 ? `, ${nivel.nivel2Name}` : '' } ${nivelNumero > 2 ? `, ${nivel.nameNivel3}` : ''} ${nivelNumero > 3 ? `, ${nivel.nivel4Name}` : '' } ${nivelNumero > 4 ? `, ${nivel.nivel5Name}` : '' }`,
                showConfirmButton: true,
                showCancelButton: true, // Habilita el botón de cancelar
                confirmButtonText: 'Sí, estoy seguro',  
                cancelButtonText:'No',
                confirmButtonColor: '#ff0000',
                denyButtonColor: '#3d4d87',
                allowEnterKey: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let activoToModify = {...draggedActivo};
                    
                    activoToModify.activoNivel1ID = nivel.nivel1ID;
                    activoToModify.nivel1Name = nivel.nivel1Name;
                    activoToModify.codNivel1 = nivel.codNivel1;                    
                    activoToModify.activoNivel2ID = nivelNumero > 1 ? nivel.nivel2ID : undefined;
                    activoToModify.nivel2Name = nivelNumero > 1 ? nivel.nivel2Name : undefined;
                    activoToModify.codNivel2 = nivelNumero > 1 ? nivel.codNivel2 : undefined;                    
                    activoToModify.activoNivel3ID = nivelNumero > 2 ? nivel.nivel3ID : undefined;
                    activoToModify.nameNivel3 = nivelNumero > 2 ? nivel.nameNivel3 : undefined;
                    activoToModify.activoNivel4ID = nivelNumero > 3 ? nivel.nivel4ID : undefined;
                    activoToModify.codNivel4 = nivelNumero > 3 ? nivel.codNivel4 : undefined;                    
                    activoToModify.activoNivel5ID = nivelNumero > 4 ? nivel.nivel5ID : undefined;
                    activoToModify.codNivel5 = nivelNumero > 4 ? nivel.codNivel5 : undefined;                    

                    let updatesUbicaciones = {
                        activoNivel1ID: activoToModify.activoNivel1ID,
                        codNivel1: activoToModify.codNivel1,
                        ...(activoToModify.activoNivel2ID ? {activoNivel2ID: activoToModify.activoNivel2ID} : {}),
                        ...(activoToModify.codNivel2 ? {codNivel2: activoToModify.codNivel2} : {}),
                        ...(activoToModify.activoNivel3ID ? {activoNivel3ID: activoToModify.activoNivel3ID} : {}),
                        ...(activoToModify.nameNivel3 ? {nameNivel3: activoToModify.nameNivel3} : {}),
                        ...(activoToModify.activoNivel4ID ? {activoNivel4ID: activoToModify.activoNivel4ID} : {}),
                        ...(activoToModify.codNivel4 ? {codNivel4: activoToModify.codNivel4} : {}),
                        ...(activoToModify.activoNivel5ID ? {activoNivel5ID: activoToModify.activoNivel5ID} : {}),
                        ...(activoToModify.codNivel5 ? {codNivel5: activoToModify.codNivel5} : {}),
                        fecha: getNewFormattedDate(),
                    }

                    let res = await actualizarUbicacionActivo(draggedActivo._id, draggedActivo.codActivo, updatesUbicaciones, usuario._id, usuario.userName);
                    if(res?.data?.msg == 'Exito') Swal.fire({
                        title: `Traslado Exitoso!`,
                        icon: 'success',
                        text: `Traslado realizado con éxito. En unos segundos lo verá reflejado en la vista Espacial`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                } else if (result.isDismissed) {
                    //Codigo a ejecutar si se clickea "No".
                }
            });
        }
    }

    const handleOverLv1 = (codLv1, event) => {
        event.preventDefault();
        event.stopPropagation();
        setOverLv1(codLv1);
        if(overLv2) setOverLv2(null);
        if(overLv3) setOverLv3(null);
    }
    const handleOverLv2 = (codLv2, event) => {
        event.preventDefault();
        event.stopPropagation();
        if(overLv1) setOverLv1(null);
        if(overLv3) setOverLv3(null);
        setOverLv2(codLv2);
    }
    const handleOverLv3 = (codLv3, event) => {
        event.preventDefault();
        event.stopPropagation();
        if(overLv1) setOverLv1(null);
        if(overLv2) setOverLv2(null);
        setOverLv3(codLv3);
    }
    const handleOverLv4 = (codLv4, event) => {
        event.preventDefault();
        event.stopPropagation();
        if(overLv1) setOverLv1(null);
        if(overLv2) setOverLv2(null);
        if(overLv3) setOverLv3(null);
        setOverLv4(codLv4);
    }
    const handleOverLv5 = (codLv5, event) => {
        event.preventDefault();
        event.stopPropagation();
        if(overLv1) setOverLv1(null);
        if(overLv2) setOverLv2(null);
        if(overLv3) setOverLv3(null);
        if(overLv4) setOverLv4(null);
        setOverLv5(codLv5);
    }

    useEffect(()=>{
        modelateNivel1s();
    },[nivel1Lista,nivel2List,nivel3List,nivel4List,nivel5List,activosModelados])

    const backgroundColor = ['#1D4ED8', '#2563EB', '#3B82F6', '#60A5FA', '#93C5FD', '#374151'];
    
    if(areasModeladas != undefined && areasModeladas.length > 0 && activosModelados != undefined && activosModelados.length > 0) return <div className="spatialTabActivosDiv"> 
        {areasModeladas.map((lv1,i) => <div key={lv1.codNivel1} 
            className={`nivel1Div ${lv1.codNivel1 == overLv1 ? 'overLv1' : ''}`} 
            onDragOver={(e)=> handleOverLv1(lv1.codNivel1, e)}  
            onDragLeave={() => setOverLv1(null)}
            onDrop={(c)=>handleOnDrop(i,lv1,1,c)}
        >
            <h3><DictionaryText text={"Nivel 1"}/>: {lv1.name}</h3>
            <div className="activosInLevel1">
                { lv1.activosPerLevel1.map(ac => <SquareActivo ac={ac} handleDragStart={handleDragStart} lvNro={1}/>) }
            </div>
            <div className="nivel2sByNivel1Div">
                {
                    lv1.nivel2s.map((p,i) => <div key={p.codNivel2} 
                        className={`nivel2Div ${p.codNivel2 == overLv2 ? 'overLv2' : ''}`}
                        onDragOver={(e) => handleOverLv2(p.codNivel2, e)}  
                        onDragLeave={() => setOverLv2(null)}
                        onDrop={(c)=>handleOnDrop(i,p,2,c)} 
                    >
                        <h4><DictionaryText text={"Nivel 2"}/>: {p.name}</h4>

                        <div className="activosInLevel2">
                            { p.activosPerLevel2?.map(ac => <SquareActivo ac={ac} handleDragStart={handleDragStart} lvNro={2}/>) }
                        </div>
                        <div className="nivel3sByNivel2Div">
                            {
                                p.nivel3s.map((lv3,i) => <div key={lv3.codNivel3} 
                                    style={{...(lv3.activosPerLevel3.length == 0 ? {padding:'1rem'} : {})}}
                                    className={`nivel3Div ${lv3.codNivel3 == overLv3 ? 'overLv3' : ''}`}
                                    onDragOver={(e) => handleOverLv3(lv3.codNivel3, e)}  
                                    onDragLeave={() => setOverLv3(null)}
                                    onDrop={(c)=>handleOnDrop(i,lv3,3,c)} 
                                >
                                    <h5><DictionaryText text={"Nivel 3"}/>: {lv3.nameNivel3}</h5>

                                    <div className="activosByNivel3Div">
                                        { lv3.activosPerLevel3.map((ac,i) => <SquareActivo ac={ac} handleDragStart={handleDragStart} lvNro={3}/>) }
                                    </div>

                                    <div className="nivel4sByNivel3Div">
                                        {
                                            lv3.nivel4s.map((lv4, i) => <div key={lv4.codNivel4}
                                                style={{...(lv4.activosPerLevel4.length == 0 ? {padding:'1rem'} : {})}}
                                                className={`nivel4Div ${lv4.codNivel4 == overLv4 ? 'overLv4' : ''}`}
                                                onDragOver={(e) => handleOverLv4(lv4.codNivel4, e)}  
                                                onDragLeave={() => setOverLv4(null)}
                                                onDrop={(c)=>handleOnDrop(i,lv4,4,c)} 
                                            >
                                                <h5><DictionaryText text={"Nivel 4"}/>: {lv4.name}</h5>
                                                <div className="activosByNivel5Div">
                                                    { lv4.activosPerLevel4.map((ac,i) => <SquareActivo ac={ac} handleDragStart={handleDragStart} lvNro={4}/>) }
                                                </div>

                                                <div className="nivel5sByNivel4Div">
                                                    {lv4.nivel5s.map((lv5,i) => <div key={lv5.codNivel5} 
                                                        style={{...(lv4.activosPerLevel4.length == 0 ? {padding:'1rem'} : {})}}
                                                        className={`nivel5Div ${lv5.codNivel5 == overLv5 ? 'overLv5' : ''}`}
                                                        onDragOver={(e) => handleOverLv5(lv5.codNivel5, e)}  
                                                        onDragLeave={() => setOverLv5(null)}
                                                        onDrop={(c)=>handleOnDrop(i,lv5,5,c)} 
                                                    >
                                                        <h5><DictionaryText text={"Nivel 5"}/>: {lv5.name}</h5>
                                                        <div className="activosByNivel5Div">
                                                            { lv5.activosPerLevel5.map((ac,i) => <SquareActivo ac={ac} handleDragStart={handleDragStart} lvNro={5}/>) }
                                                        </div>
                                                    </div>)}
                                                </div>

                                            </div>)
                                        }
                                    </div>

                                </div>)
                            }
                        </div>
                    </div>)
                }
            </div>
        </div>)}
    </div>
    else if(areasModeladas == undefined) return <h3 className="warningStatusMsg"> Cargando <span>.</span><span>.</span><span>.</span></h3>
    else if(activosModelados != undefined && activosModelados.length == 0) return <h3 className="warningStatusMsg">
        No hay activos cargados
    </h3>

}

export default SpatialTabActivos;